import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Stockitem } from '../../../../../interfaces/stockitem';
import { UserService } from '../../../../../services/user';
import { ItemsService } from '../../../../../services/items.service';
import { PetServices } from '../../../../../services/petservices';



@Component({
  selector: 'app-allservicesmobile',
  templateUrl: './allservicesmobile.component.html',
  styleUrl: './allservicesmobile.component.scss'
})
export class AllservicesmobileComponent implements OnInit {
  searchKey: string = '';
  searched: boolean = false;

  pageIndex: number = 1;
  pageSize: number = 10;
  totalItems: number = 0;
  stockTotal: number = 0;

  allData: Stockitem[] = [];
  allWareHouses: any[] = [];

  contentReady: boolean = true;
  loadingMore: boolean = false;
  noData: boolean = false;
  hasMore: boolean = false;

  cartPopUp: boolean = false;
  isStockTaking: boolean = false;

  cartItems: any[] = [];
  cartItemCount: number = 0;

  warehouseId: number | null = null;

  accountType: string = '';
  isAdmin: boolean = false;
  isSubAdmin: boolean = false;
  isSuperAdmin: boolean = false;

  isAr: boolean = localStorage.getItem('language') === 'ar';

  constructor(
    private router: Router,
    private _userService: UserService,
    private _ItemsService: ItemsService,
    private _petServices: PetServices
  ) {}

  ngOnInit(): void {
    const posId = localStorage.getItem('posId');
    this.warehouseId = posId ? Number(posId) : null;

    this.loadStoredCart();
    this.loadWarehouses();
    this.loadUserRole();
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;
    const bottomReached = scrollPosition + windowHeight >= pageHeight - 120;

    if (bottomReached) {
      this.loadMore();
    }
  }

  private loadStoredCart(): void {
    const currentWarehouseId = this.getCurrentWarehouseId();
    const cartWarehouseId = localStorage.getItem('cartWarehouseId');

    if (cartWarehouseId && currentWarehouseId && cartWarehouseId !== currentWarehouseId) {
      this.clearCart();
      return;
    }

    const storedCart = localStorage.getItem('cart');

    if (!storedCart) {
      return;
    }

    try {
      this.cartItems = JSON.parse(storedCart) || [];
      this.cartItemCount = this.cartItems.length;
    } catch {
      this.clearCart();
    }
  }

  private loadWarehouses(): void {
    this._ItemsService.getWearHouses().subscribe({
      next: (res) => {
        this.allWareHouses = res.warehouse || [];
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  private loadUserRole(): void {
    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];

        this.isAdmin = this.accountType === '1' || this.accountType === '10';
        this.isSuperAdmin = this.accountType === '10';
        this.isSubAdmin = this.accountType === '6';

        if (this.warehouseId) {
          this.getServicesByWarehouse(1, this.pageSize, false);
        } else {
          this.noData = true;
          this.contentReady = false;
        }
      },
      error: (error) => {
        console.error(error);
        this.contentReady = false;
      }
    });
  }

  onEnterPressed(): void {
    this.search();
  }

  search(): void {
    const keyword = this.searchKey.trim();

    this.pageIndex = 1;
    this.searched = !!keyword;
    this.allData = [];
    this.hasMore = false;

    if (keyword) {
      this.searchServices(1, this.pageSize, keyword, false);
    } else {
      this.getServicesByWarehouse(1, this.pageSize, false);
    }
  }

  clearSearch(): void {
    this.searchKey = '';
    this.searched = false;
    this.pageIndex = 1;
    this.allData = [];
    this.hasMore = false;

    this.getServicesByWarehouse(1, this.pageSize, false);
  }

  loadMore(): void {
    if (
      this.contentReady ||
      this.loadingMore ||
      this.noData ||
      !this.hasMore ||
      !this.warehouseId
    ) {
      return;
    }

    const nextPage = this.pageIndex + 1;

    if (this.searched && this.searchKey.trim()) {
      this.searchServices(nextPage, this.pageSize, this.searchKey.trim(), true);
    } else {
      this.getServicesByWarehouse(nextPage, this.pageSize, true);
    }
  }

  applyWareHouse(id: any): void {
    this.warehouseId = Number(id);
    localStorage.setItem('posId', String(this.warehouseId));

    this.searchKey = '';
    this.searched = false;
    this.pageIndex = 1;
    this.allData = [];
    this.hasMore = false;

    this.clearCart();
    this.cartPopUp = false;

    this.getServicesByWarehouse(1, this.pageSize, false);
  }

  getServicesByWarehouse(
    page: number = 1,
    perPage: number = 10,
    append: boolean = false
  ): void {
    if (!this.warehouseId) {
      this.noData = true;
      this.contentReady = false;
      this.loadingMore = false;
      return;
    }

    if (append) {
      this.loadingMore = true;
    } else {
      this.contentReady = true;
    }

    this._petServices.getByWarehouse(this.warehouseId, page, perPage).subscribe({
      next: (res: any) => {
        const newItems = res.data || [];

        this.allData = append ? [...this.allData, ...newItems] : newItems;

        this.totalItems = Number(res.total || 0);
        this.stockTotal = Number(res.total || 0);
        this.pageIndex = Number(res.current_page || page);

        this.noData = this.allData.length === 0;
        this.hasMore = this.allData.length < this.totalItems;

        this.contentReady = false;
        this.loadingMore = false;
      },
      error: (err) => {
        console.log(err);

        if (!append) {
          this.allData = [];
          this.totalItems = 0;
          this.stockTotal = 0;
          this.noData = true;
        }

        this.contentReady = false;
        this.loadingMore = false;
      }
    });
  }

  searchServices(
    page: number = 1,
    perPage: number = 10,
    search: string = '',
    append: boolean = false
  ): void {
    if (!this.warehouseId) {
      this.noData = true;
      this.contentReady = false;
      this.loadingMore = false;
      return;
    }

    if (append) {
      this.loadingMore = true;
    } else {
      this.contentReady = true;
    }

    this._petServices.searchServices(this.warehouseId, search, page, perPage).subscribe({
      next: (res: any) => {
        const newItems = res.data || [];

        this.allData = append ? [...this.allData, ...newItems] : newItems;

        this.totalItems = Number(res.total || 0);
        this.stockTotal = Number(res.total || 0);
        this.pageIndex = Number(res.current_page || page);

        this.noData = this.allData.length === 0;
        this.hasMore = this.allData.length < this.totalItems;

        this.contentReady = false;
        this.loadingMore = false;
      },
      error: (err) => {
        console.log(err);

        if (!append) {
          this.allData = [];
          this.totalItems = 0;
          this.stockTotal = 0;
          this.noData = true;
        }

        this.contentReady = false;
        this.loadingMore = false;
      }
    });
  }

  edit(itemobj: any): void {
    this.router.navigate(['/AddService'], { queryParams: itemobj });
  }

  clone(itemobj: any): void {
    this.router.navigate(['/AddService'], {
      queryParams: { ...itemobj, isClone: true }
    });
  }

  deleteitem(id: string): void {
    Swal.fire({
      title: this.isAr ? 'متأكد؟' : 'Are you sure?',
      showCancelButton: true,
      confirmButtonText: this.isAr ? 'نعم' : 'Yes',
      cancelButtonText: this.isAr ? 'لا' : 'No'
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      this.contentReady = true;

      this._petServices.delete(parseInt(id, 10)).subscribe({
        next: () => {
          this.pageIndex = 1;
          this.allData = [];

          if (this.searched && this.searchKey.trim()) {
            this.searchServices(1, this.pageSize, this.searchKey.trim(), false);
          } else {
            this.getServicesByWarehouse(1, this.pageSize, false);
          }
        },
        error: (err) => {
          console.log(err);
          this.contentReady = false;
        }
      });
    });
  }

  addToCart(item: any): void {
    const index = this.cartItems.findIndex((cartItem) => cartItem.id === item.id && cartItem.cartItemType === 'service');

    if (index !== -1) {
      this.cartItems.splice(index, 1);
    } else {
      this.cartItems.push({ ...item, cartItemType: 'service' });
    }

    this.saveCart();
  }

  removeFromCart(item: any): void {
    const itemType = item.cartItemType || 'service';
    const index = this.cartItems.findIndex((cartItem) => cartItem.id === item.id && (cartItem.cartItemType || 'service') === itemType);

    if (index !== -1) {
      this.cartItems.splice(index, 1);
      this.saveCart();
    }

    this.cartItemCount = this.cartItems.length;

    if (this.cartItems.length === 0) {
      this.cartPopUp = false;
      this.clearCart();
    }
  }

  isInCart(item: any): boolean {
    return this.cartItems.some((cartItem) => cartItem.id === item.id && cartItem.cartItemType === 'service');
  }

  quickOrder(): void {
    this.router.navigate(['/Addorderstore'], {
      queryParams: {
        cart: JSON.stringify(this.cartItems),
        warehouseIdFromCart: this.warehouseId
      }
    });
  }

  cartPopUpOpen(): void {
    if (this.cartItemCount > 0) {
      this.cartPopUp = true;
    }
  }

  close(): void {
    this.cartPopUp = false;
  }

  private saveCart(): void {
    this.cartItemCount = this.cartItems.length;

    if (!this.cartItems.length) {
      this.clearCart();
      return;
    }

    const currentWarehouseId = this.getCurrentWarehouseId();
    this.cartItems = this.cartItems.map(item => ({
      ...item,
      cartItemType: item.cartItemType || (item.quantity !== undefined ? 'product' : 'service')
    }));
    localStorage.setItem('cart', JSON.stringify(this.cartItems));

    if (currentWarehouseId) {
      localStorage.setItem('cartWarehouseId', currentWarehouseId);
    }
  }

  private clearCart(): void {
    this.cartItems = [];
    this.cartItemCount = 0;
    localStorage.removeItem('cart');
    localStorage.removeItem('cartWarehouseId');
  }

  private getCurrentWarehouseId(): string | null {
    return this.warehouseId ? String(this.warehouseId) : localStorage.getItem('posId');
  }

  getPetTypeKey(value: any): string {
    switch (String(value)) {
      case '0':
        return 'allServicesMobile.petTypes.adult';
      case '1':
        return 'allServicesMobile.petTypes.kitten';
      case '2':
        return 'allServicesMobile.petTypes.sterilized';
      case '3':
        return 'allServicesMobile.petTypes.persian';
      case '4':
        return 'allServicesMobile.petTypes.puppy';
      case '5':
        return 'allServicesMobile.petTypes.birds';
      case '6':
        return 'allServicesMobile.petTypes.other';
      default:
        return 'allServicesMobile.common.notAvailable';
    }
  }

  getPetKey(value: any): string {
    switch (String(value)) {
      case '0':
        return 'allServicesMobile.pets.cats';
      case '1':
        return 'allServicesMobile.pets.dogs';
      case '2':
        return 'allServicesMobile.pets.birds';
      case '4':
        return 'allServicesMobile.pets.catsAndDogs';
      case '3':
        return 'allServicesMobile.pets.other';
      default:
        return 'allServicesMobile.common.notAvailable';
    }
  }

  fixImage(url: any): string {
    if (!url) {
      return '';
    }

    if (String(url).startsWith('http')) {
      return url;
    }

    return `https://backendproduction.blueboxpet.com/storage/app/public/${url}`;
  }

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.style.display = 'none';
  }
}
